import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { map, Observable, shareReplay } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from '../../../core/services/auth.service';
import { MenuService } from '../../services/menu.service';
import { nav_path } from 'src/app/app-routing.module';
import { LocalStorageRefService } from '../../../core/services/local-storage/local-storage-ref.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  @ViewChild('sidenav') private sidenav!: MatSidenav;
  @ViewChild('sidenavEl', { read: ElementRef }) sidenavEl!: ElementRef;
  public nav_path = nav_path;
  private isLargeScreen = false;
  public showMenu = false;

  /* '(min-width: 992px)' is 'lg' in styles.scss - CHANGE WITH CAUTION */
  isLarge$: Observable<boolean> = this.breakpointObserver.observe('(min-width: 992px)')
    .pipe(
      map(result => {
        this.isLargeScreen = result.matches;
        return result.matches;
      }),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    public auth: AuthService,
    public menuService: MenuService,
    private localStorage: LocalStorageRefService
  ) {
    this.showMenu = localStorage.localStorage.getItem('expandSideNav') === 'true';
  }

  toggleMenu() {
    if (!this.isLargeScreen) this.sidenav.toggle();
    else {
      this.localStorage.localStorage.setItem('expandSideNav', `${!this.showMenu}`);
      this.showMenu = !this.showMenu;
    }
  }

}
